<template>
    <div class="animation-feedback" ref="feedbackTextParent">
        <span class="feedback-text" ref="feedbackText">
            <slot name="message"></slot>
        </span>
    </div>
</template>
<style scoped>
.animation-feedback {
    display: flex;
    align-items: center;
    justify-content: center;
}

.feedback-text {
    position: relative;
    display: block;
    padding: 10px 20px;
    min-height: 52px;
}
</style>
<script>
/* eslint-disable */
import gsap from "gsap"
import utilities from "@/base/utilities"
export default {
    props: {
      thrilled: Boolean,
      thanks: Boolean,
      sad: Boolean
    },
    data(){
      return {
        maxParticles: 10
      }
    },

    computed: {
      reactionSrc() {
        if(this.thrilled) {
          return require('@/assets/star.png')
        } else if(this.thanks){
          return require('@/assets/like.png')
        } else if(this.sad){
          return require('@/assets/emoji-cry.png')
        } else {
          return ''
        }
      }
    },

    mounted() {
      this.$nextTick(() => {
        for (let i = 0; i <= 20; i++) {
            this.createParticles()
            this.animateThoseParticles()
        }
      })
    },

    methods: {
        createParticles() {
            const canvas = this.$refs.feedbackText
            const canvasWidth = canvas.getBoundingClientRect().width
            const canvasHeight = canvas.getBoundingClientRect().height
            const star = document.createElement('span')
            star.classList.add('particle-star')
            star.style.backgroundImage = `url(${this.reactionSrc})`
            star.style.width = "30px"
            star.style.height = "30px"
            star.style.position = "absolute"
            star.style.top = 0
            star.style.left = "50%"
            gsap.set(star, {
                autoAlpha: 0,
                y: -1 * utilities.getRandom(0, canvasHeight),
                xPercent: '-50',
                x: utilities.getRandom(-1 * (canvasWidth / 2), (canvasWidth / 2)),
                scale: utilities.getRandom(0.3, 0.8)
            })

            this.$refs.feedbackText.appendChild(star)
        },

        
        animateThoseParticles() {
            const stars = this.$refs.feedbackText.querySelectorAll('.particle-star')
            const canvasHeight = this.$refs.feedbackText.getBoundingClientRect().height
            //const canvasWidth = this.$refs.feedbackText.getBoundingClientRect().width
            const canvasParentWidth = (this.$refs.feedbackTextParent.getBoundingClientRect().width/2) - 50
            gsap.timeline({
                    delay: 0.2
                })
                .to(stars, {
                    duration: 0.8,
                    y: gsap.utils.wrap([canvasHeight < 50 ? 52 : canvasHeight]),
                    autoAlpha: 1,
                    stagger: 0.05,
                    ease: "bounce.out"
                }, 0)
                .to(stars, {
                    duration: 0.8,
                    x: gsap.utils.wrap(['+=50', '-=50', '+=20', '-=20']),
                    stagger: 0.05,
                }, 0)
                .to(stars, {
                    duration: 0.5,
                    autoAlpha: 0
                })
        }
    }
}
</script>